/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionPhase } from './oralExamSessionPhase';
import type { OralExamTimeSlotStateResponseInExamEnteredAt } from './oralExamTimeSlotStateResponseInExamEnteredAt';
import type { OralExamTimeSlotStateResponseBrieferId } from './oralExamTimeSlotStateResponseBrieferId';
import type { OralExamTimeSlotStateResponseSlotOwnerId } from './oralExamTimeSlotStateResponseSlotOwnerId';
import type { OralExamSupervisorEntryResponse } from './oralExamSupervisorEntryResponse';
import type { OralExamTimeSlotStateResponseStageGate } from './oralExamTimeSlotStateResponseStageGate';
import type { OralExamTimeSlotStateResponseEtag } from './oralExamTimeSlotStateResponseEtag';

/**
 * Shared examination state for one time slot, after start or while polling.

Deprecated name, retired 2026-09-22: ``OralExamCohortStateResponse``.
 */
export interface OralExamTimeSlotStateResponse {
  sessionPhase: OralExamSessionPhase;
  inExamEnteredAt?: OralExamTimeSlotStateResponseInExamEnteredAt;
  admittedBookingIds?: string[];
  brieferId?: OralExamTimeSlotStateResponseBrieferId;
  slotOwnerId?: OralExamTimeSlotStateResponseSlotOwnerId;
  supervisors?: OralExamSupervisorEntryResponse[];
  stageGate?: OralExamTimeSlotStateResponseStageGate;
  etag?: OralExamTimeSlotStateResponseEtag;
}
